<template>
  <div class="e-role-editor table">
    <table>
      <thead>
      <th></th>
      <th
        v-for="permissionName in permsArr"
        :key="permissionName"
      >
        {{PERMS_SERVER_CONFIG[permissionName] ? PERMS_SERVER_CONFIG[permissionName].label : permissionName}}
      </th>
      </thead>
      <tbody>
      <tr
        v-for="row in showedPermissionList"
        :key="row.id"
      >
        <td>
          {{row.name}}
        </td>
        <td
          v-for="permissionName in permsArr"
          :key="`${row.id}_${permissionName}`"
        >
          <div class="center">
            <label class="checked">
              <input type="checkbox"
                     v-model="model[name]"
                     :name="name"
                     class="checkbox"
                     @click="onClick($event, permissionName, row.prefix)"
                     :value="`${row.prefix}-${permissionName}`"/>
              <span></span>
            </label>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import {PERMS_SERVER_CONFIG, PERMS_SERVER} from '../../config/permissions.js'

  export default {
    name: 'e-role-editor',
    props: {
      model: {
        type: Object,
        required: true
      },
      name: {
        type: String,
        default: null,
        required: true
      },
      permissionList: {
        type: Array,
        default: function () {
          return []
        }
      }
    },
    computed: {
      showedPermissionList () {
        const list = []
        const permissionList = this.permissionList
        let counter = 0
        permissionList.forEach(v => {
          if (v.permissions && Array.isArray(v.permissions) && v.prefix) {
            list.push(Object.assign(v, {
              id: v.id || ++counter
            }))
          } else {
            console.warn('ignore perms(no prefix or permissions[])', v)
          }
        })
        return list
      },
      PERMS_SERVER_CONFIG () {
        return PERMS_SERVER_CONFIG
      },
      permsArr () {
        let arr = []
        if (Array.isArray(this.permissionList)) {
          this.permissionList.forEach(v => {
            if (v.permissions && Array.isArray(v.permissions) && v.prefix) {
              v.permissions.forEach(p => {
                if (p && p.id) {
                  let postfixs = p.id.split('-')
                  let postfix = postfixs[postfixs.length - 1]
                  if (arr.indexOf(postfix) === -1) {
                    arr.push(postfix)
                  }
                } else {
                  console.warn('ignore perms(no id or prefix)', v)
                }
              })
            } else {
              console.warn('ignore perms(no prefix or permissions[])', v)
            }
          })
        }
        return arr
      }
    },
    methods: {
      onClick (e, permissionName, prefix) {
        let el = e.target || e.srcElement
        if (el.checked) {
          if (permissionName !== PERMS_SERVER.VIEW) {
            this.model[this.name].push(`${prefix}-${PERMS_SERVER.VIEW}`)
          }
        } else {
          // if uncheck read, uncheck all perms for that prefix
          if (permissionName === PERMS_SERVER.VIEW) {
            this.model[this.name] = this.model[this.name].filter(v => v.indexOf(`${prefix}-`) === -1)
          }
        }
      }
    }
  }
</script>
